export default {
  state: {
    translations: {},
  },
  getters: {
    getTranslations(state) {
      return state.translations;
    },
    getAddToCart(state) {
      return state.translations.addToCart;
    },
    getExpandSection(state) {
      return state.translations.expand;
    },
    getCollapseSection(state) {
      return state.translations.collapse;
    },
    getAccessoriesTabError(state) {
      return state.translations.accessoriesTabError;
    },
    getTabNoAccessories(state) {
      return state.translations.accessoriesTabNoAccessories;
    },
    getAccessoriesJsonUrl(state) {
      return state.translations.accessoriesJsonUrl;
    },
    getPriceSaveText(state) {
      return state.translations.save;
    },
    getDevicesJsonUrl(state) {
      return state.translations.devicesJsonUrl;
    },
    getProductUrl(state) {
      return state.translations.productUrl;
    },
    getCompatibleTitle(state) {
      return state.translations.compatibleTitle;
    },
    getManualsUrl(state) {
      return state.translations.manualsUrl;
    },
    getManualsJsonUrl(state) {
      return state.translations.manualsJsonUrl;
    },
    getFaqJsonUrl(state) {
      return state.translations.faqJsonUrl;
    },
    getCompatibleProductsJsonUrl(state) {
      return state.translations.compatibleProductsJsonUrl;
    },
    getCrossSellsJsonUrl(state) {
      return state.translations.crossSellsJsonUrl;
    },
    getUpSellsJsonUrl(state) {
      return state.translations.upSellsJsonUrl;
    },
    getMapsJsonUrl(state, getters) {
      return getters.getTranslations.mapsJsonUrl;
    },
    getAddToCartUrl(state, getters) {
      return getters.getTranslations.addToCartUrl;
    },
    getAddToCartUrlOld(state, getters) {
      return getters.getTranslations.addToCartUrlOld;
    },
    getCheckAvailableSeats(state, getters) {
      return getters.getTranslations.checkAvailableSeats;
    },
    getAvailableSeatsUrl(state, getters) {
      return getters.getTranslations.availableSeatsUrl;
    },
    getSeoUrl(state, getters) {
      return getters.getTranslations.seoUrl;
    },
    getViewCartUrl(state, getters) {
      return getters.getTranslations.viewCartUrl;
    },
    getVatToolTip(state, getters) {
      return getters.getTranslations.vatToolTip;
    },
    getShowVatToolTip(state, getters) {
      return !!getters.getVatToolTip;
    },
    getPartNumberTitle(state, getters) {
      return getters.getTranslations.partNumber;
    },
    getMapFormatNames(state, getters) {
      return getters.getTranslations.mapFormatTranslations;
    },
    getCustomerGroupJsonUrl(state, getters) {
      return getters.getTranslations.customerGroupJsonUrl;
    },
    getReactivateCustomerGroup(state, getters) {
      return getters.getTranslations.reactivateCustomerGroup;
    },
    getAddedToCart(state) {
      return state.translations.addedToCart;
    },
    getContinueShopping(state) {
      return state.translations.continueShopping;
    },
    getViewCart(state) {
      return state.translations.viewCart;
    },
    getShopForAccessories(state) {
      return state.translations.shopForAccessories;
    },
    getInterstitialApiErrorMessage(state) {
      return state.translations.interstitialApiErrorMessage;
    },
  },
  mutations: {
    setTranslations(state, payload) {
      state.translations = payload;
    },
  },
  actions: {
    setContent({ commit }, payload) {
      commit('setTranslations', payload);
    },
  },
};
